module.exports = __webpack_public_path__ + "img/hf.83d3bdb6.png";